<template>
  <div class="v-paginate flex items-center" :class="variant">
    <p v-if="showCount !== undefined" class="whitespace-nowrap font-medium mb-0 mr-6 text-current text-sm">{{ currentPage }} / {{ max }}</p>
    <div class="whitespace-nowrap">
      <button
        class="v-paginate-left appearance-none"
        :disabled="currentPage === min"
        data-testid="v-paginate-prev"
        @click="$emit('change-page', currentPage - 1)"
      >
        <ChevronLeftIcon class="w-4" :class="{ disabled: currentPage === min }" />
      </button>
      <button
        class="v-paginate-right appearance-none"
        :disabled="currentPage === max"
        data-testid="v-paginate-next"
        @click="$emit('change-page', currentPage + 1)"
      >
        <ChevronRightIcon class="w-4" :class="{ disabled: currentPage === max }" />
      </button>
    </div>
  </div>
</template>
<script lang="ts" setup>
export type VPaginateVariant = 'light' | 'dark'
import type { PropType } from 'vue'
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/vue/24/outline'

defineProps({
  min: {
    type: Number,
    default: 1,
  },
  max: {
    type: Number,
    required: true,
  },
  currentPage: {
    type: Number,
    required: true,
  },
  showCount: {
    type: String,
    default: undefined,
  },
  variant: {
    type: String as PropType<VPaginateVariant>,
    required: true,
  },
})

defineEmits(['change-page'])
</script>

<style lang="stylus" scoped>
.v-paginate
  &-left
    @apply border-2 border-r-0 rounded-l-lg py-2 px-3

  &-right
    @apply border-2 rounded-r-lg py-2 px-3

  &.light
    button
      @apply bg-transparent border-gray-200

    .disabled
      @apply text-gray-300

  &.dark
    button
      @apply bg-gray-900 border-gray-400
      --tw-bg-opacity: 0.05

    .disabled
      @apply text-gray-500
</style>
